// CAO Studio brand kit. Import the tokens once at the app root (main.tsx), then use the components anywhere:
//   import "./brand/tokens.css";
//   import { Logo, Mark, FormatBadge } from "./brand";
export { Logo, Mark, type LogoColorMode, type LogoProps, type MarkProps, type MarkState } from "./Logo";
export { FormatBadge, FormatIcon, type FormatBadgeProps, type FormatIconProps } from "./FormatBadge";
export { FORMAT_BRAND, FORMAT_GROUPS, FORMAT_ORDER, GELS, formatIconSvg, type FormatGroup, type FormatId } from "./formats";
export { CHAIR, CHAIR_SMALL, CHAIR_TILE, LOGO_COLORS, chairSvgInner, markSvgInner } from "./geometry";

/** Brand words, for titles, meta tags and the Director's self-description. */
export const BRAND = {
  name: "CAO Studio",
  domain: "cao.studio",
  tagline: "Direct your creative vision.",
  descriptor: "The video studio you talk to.",
  oneLiner: "Talk to the Director and make any kind of video: ads, documentaries, cartoons, trailers, explainers and more. You approve every step.",
  director: "the Director",
} as const;
